import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { CompanyResponse } from '@schemax-whatsapp/shared-models';
import { CompanyService } from './company.service';
import { CompanyIdRequest } from './models/company-id.request';
import { CompanyModel } from './models/company.model';
@ApiTags('Company')
@Controller('company')
export class CompanyController {
    constructor(
        private companyService: CompanyService,
        private applicationExceptionHandler: ApplicationExceptionHandler
    ) {
    }

    @Post('/createCompany')
    async createCompany(@Body() companyReq: CompanyModel): Promise<CompanyResponse> {
        try {
            return await this.companyService.createCompany(companyReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CompanyResponse, error);
        }
    }

    @Post('/editCompany')
    async editCompany(@Body() companyReq: CompanyModel): Promise<CompanyResponse> {
        try {
            return await this.companyService.editCompany(companyReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CompanyResponse, error);
        }
    }

    @Post('/getAllCompanies')
    async getAllCompanies(): Promise<CompanyResponse> {
        try {
            return await this.companyService.getAllCompanies();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CompanyResponse, error);
        }
    }

    @Post('/deleteCompany')
    async deleteCompany(@Body() companyReq: CompanyIdRequest): Promise<CompanyResponse> {
        try {
            return await this.companyService.deleteCompany(companyReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CompanyResponse, error);
        }
    }


}
